/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiCallSourceFromJSON, StreemApiCallSourceToJSON, } from './';
export function StreemApiCompanyFromJSON(json) {
    return StreemApiCompanyFromJSONTyped(json, false);
}
export function StreemApiCompanyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sid': !exists(json, 'sid') ? undefined : json['sid'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'parentCompanySid': !exists(json, 'parent_company_sid') ? undefined : json['parent_company_sid'],
        'subCompanyLimit': !exists(json, 'sub_company_limit') ? undefined : json['sub_company_limit'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'activeStatusModifiedAt': !exists(json, 'active_status_modified_at') ? undefined : (new Date(json['active_status_modified_at'])),
        'callSources': !exists(json, 'call_sources') ? undefined : (json['call_sources'].map(StreemApiCallSourceFromJSON)),
    };
}
export function StreemApiCompanyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sid': value.sid,
        'code': value.code,
        'name': value.name,
        'active': value.active,
        'parent_company_sid': value.parentCompanySid,
        'sub_company_limit': value.subCompanyLimit,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'active_status_modified_at': value.activeStatusModifiedAt === undefined ? undefined : (value.activeStatusModifiedAt.toISOString()),
        'call_sources': value.callSources === undefined ? undefined : (value.callSources.map(StreemApiCallSourceToJSON)),
    };
}
//# sourceMappingURL=StreemApiCompany.js.map